export default {
  expensesFor: '{month} Užsakymai',
  clickTooltip: 'Spustelėjus vardą galima sužinoti daugiau informacijos',
  name: 'Vardas',
  days: 'Dienos',
  cost: 'Kaina',
  totalCost: 'Bendra suma: {total}€',
  hasBeenPaid: 'Sumokėta',
  date: 'Data',
  soup: 'Sriuba(-os)',
  mainDish: 'Pagrindinis patiekalas(-ai)',
  actualPrice: 'Bendra suma',
  paidPrice: 'Suma',
  city: 'Miestas',
};
